import { Button } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { Modal } from "@msuite/ui/modal";
import { NotificationPreferences } from "@/components/notification-preferences";

/** Props Interface */
interface ProfileModalProps {
	isOpen: boolean;
	onClose: () => void;
}

/**
 * The signed-in person's settings. Every switch inside saves on its own, so the footer carries
 * nothing to submit — only the way out.
 */
export function ProfileModal({ isOpen, onClose }: ProfileModalProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={t("settings.settings")}
			width="min(720px, 95vw)"
		>
			<Modal.Body>
				<Modal.TableWrapper>
					<NotificationPreferences />
				</Modal.TableWrapper>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onClose}>{t("general.close")}</Button>
			</Modal.Footer>
		</Modal>
	);
}
